/* DGA - Mega menu: desktop hover-intent/toetsenbord + mobiele drill-down in de thema-drawer.
   Hoort bij sections/dga-mega-menu.liquid. */
(function(){
  var root = document.querySelector('[data-dga-mm]');
  if(!root || root.dataset.dgaMmInit) return;
  root.dataset.dgaMmInit = '1';

  /* ------------------------------------------------------------------
     DESKTOP: balk in de sticky header-wrapper hangen (zoals header-megamenu),
     hover-intent (120ms open / 180ms dicht), klik, toetsenbord, ESC, klik buiten.
     ------------------------------------------------------------------ */
  var wrapper = document.querySelector('.header-wrapper');
  if(wrapper && root.parentNode !== wrapper){ wrapper.appendChild(root); }

  var groups = [].slice.call(root.querySelectorAll('[data-dga-group]'));
  var canHover = window.matchMedia('(hover: hover)').matches;

  function setOpen(g, open){
    g.classList.toggle('is-open', open);
    var t = g.querySelector('.dga-mm__trigger');
    if(t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except){ groups.forEach(function(g){ if(g !== except) setOpen(g, false); }); }

  groups.forEach(function(g){
    var trig = g.querySelector('.dga-mm__trigger');
    if(!trig) return;
    trig.addEventListener('click', function(e){
      e.preventDefault();
      var willOpen = !g.classList.contains('is-open');
      closeAll(g); setOpen(g, willOpen);
    });
    trig.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown'){
        e.preventDefault(); closeAll(g); setOpen(g, true);
        var first = g.querySelector('.dga-mm__panel a');
        if(first) first.focus();
      }
    });
    if(canHover){
      var openTimer = null, closeTimer = null;
      g.addEventListener('mouseenter', function(){
        clearTimeout(closeTimer);
        openTimer = setTimeout(function(){ closeAll(g); setOpen(g, true); }, 120);
      });
      g.addEventListener('mouseleave', function(){
        clearTimeout(openTimer);
        closeTimer = setTimeout(function(){ setOpen(g, false); }, 180);
      });
    }
  });

  document.addEventListener('keydown', function(e){
    var open = root.querySelector('.dga-mm__group.is-open');
    if(!open) return;
    if(e.key === 'Escape'){
      var trig = open.querySelector('.dga-mm__trigger');
      closeAll(null); if(trig) trig.focus(); return;
    }
    if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var panel = open.querySelector('.dga-mm__panel');
    if(!panel || !panel.contains(document.activeElement)) return;
    e.preventDefault();
    var links = [].slice.call(panel.querySelectorAll('a'));
    var i = links.indexOf(document.activeElement);
    var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
    if(next < 0) next = links.length - 1;
    if(next >= links.length) next = 0;
    links[next].focus();
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('[data-dga-group]')) closeAll(null);
  });
  /* Focus verlaat het menu (Tab) -> sluiten */
  root.addEventListener('focusout', function(){
    setTimeout(function(){ if(!root.contains(document.activeElement)) closeAll(null); }, 0);
  });

  /* ------------------------------------------------------------------
     TRACKING: elke klik op een menulink naar de dataLayer (GTM pikt 'dga_menu_click' op).
     menu_panel = het top-item, menu_item = linktekst, menu_device = desktop|mobile.
     ------------------------------------------------------------------ */
  function trackClick(a, device){
    var panel = '';
    if(device === 'desktop'){
      var g = a.closest('[data-dga-group]');
      var t = g && g.querySelector('.dga-mm__trigger');
      panel = t ? t.textContent.trim() : (a.classList.contains('dga-mm__cta') ? 'cta' : '');
    } else {
      var pane = a.closest('.dga-mob__pane');
      panel = pane ? (pane.getAttribute('data-title') || '') : (a.closest('.dga-mob__footer') ? 'footer' : '');
    }
    var name = (a.querySelector('.dga-mm__item-name, .dga-mm__card-title, .dga-mm__list-name, .dga-mob__link-name, .dga-mob__card-title, .dga-mob__kh-title') || a).textContent.trim().replace(/\s+/g, ' ');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'dga_menu_click',
      menu_device: device,
      menu_panel: panel,
      menu_item: name,
      menu_url: a.getAttribute('href') || ''
    });
  }
  root.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if(a) trackClick(a, 'desktop');
  });

  /* Paneelhoogte: onderkant van de balk meten (header klapt in bij scrollen) */
  /* Snelheid (29-10-2026): hooguit één meting per beeldframe en alleen schrijven als de waarde verandert;
     elke scrollgebeurtenis meten en zetten kostte tot 1,3 s rekentijd tijdens het scrollen. */
  var navOffset = -1, navFrame = 0;
  function setNavOffset(){
    navFrame = 0;
    var bar = root.querySelector('.dga-mm__bar');
    if(!bar) return;
    var v = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    if(v === navOffset) return;
    navOffset = v;
    root.style.setProperty('--dga-nav-offset', v + 'px');
  }
  function queueNavOffset(){ if(!navFrame) navFrame = requestAnimationFrame(setNavOffset); }
  setNavOffset();
  window.addEventListener('resize', queueNavOffset);
  window.addEventListener('scroll', queueNavOffset, { passive: true });

  /* ------------------------------------------------------------------
     MOBIEL: drill-down in de thema-drawer. Pas na DOMContentLoaded, zodat de
     MenuDrawer-class uit global.js (deferred) onze knoppen NIET als
     "sluit submenu"-knoppen bindt: zij bindt alleen wat er dan al staat.
     ------------------------------------------------------------------ */
  function initMobile(){
    var mob = document.querySelector('[data-dga-mob]');
    var target = document.querySelector('#Details-menu-drawer-container .menu-drawer__navigation');
    var details = document.getElementById('Details-menu-drawer-container');
    if(!mob || !target) return;
    target.innerHTML = '';
    target.classList.add('dga-mob-host');
    target.appendChild(mob);
    mob.removeAttribute('hidden');

    var stack = ['root'];
    var titleEl = mob.querySelector('[data-dga-mob-title]');
    var backBtn = mob.querySelector('[data-dga-mob-back]');
    var panes = [].slice.call(mob.querySelectorAll('.dga-mob__pane'));

    function paneById(id){ return mob.querySelector('.dga-mob__pane[data-pane="' + id + '"]'); }
    function render(dir){
      var current = stack[stack.length - 1];
      panes.forEach(function(p){ p.classList.remove('is-active', 'is-back'); });
      var cur = paneById(current) || paneById('root');
      cur.classList.add('is-active');
      if(dir === 'back') cur.classList.add('is-back');
      if(titleEl) titleEl.textContent = cur.getAttribute('data-title') || '';
      if(backBtn) backBtn.classList.toggle('is-show', stack.length > 1);
      var scroller = mob.closest('.menu-drawer__inner-container');
      if(scroller) scroller.scrollTop = 0;
    }
    function go(id){
      if(!paneById(id)) return;
      stack.push(id); render('fwd');
      var pane = paneById(id);
      pane.setAttribute('tabindex', '-1');
      pane.focus({ preventScroll: true });
    }
    function back(){
      if(stack.length < 2) return;
      stack.pop(); render('back');
      if(backBtn) backBtn.focus();
    }
    mob.addEventListener('click', function(e){
      var a = e.target.closest('a[href]');
      if(a) trackClick(a, 'mobile');
      var go_ = e.target.closest('[data-dga-mob-go]');
      if(go_){ e.preventDefault(); go(go_.getAttribute('data-dga-mob-go')); return; }
      if(e.target.closest('[data-dga-mob-back]')){ e.preventDefault(); back(); return; }
      if(e.target.closest('[data-dga-mob-close]')){
        e.preventDefault();
        var summary = document.querySelector('#Details-menu-drawer-container > summary');
        if(summary) summary.click();
      }
    });
    /* ESC op een subscherm gaat een niveau terug; de drawer zelf luistert al op ESC. */
    mob.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && stack.length > 1){ e.stopPropagation(); back(); }
    });
    /* Drawer dicht -> terug naar het hoofdscherm */
    if(details){
      details.addEventListener('toggle', function(){
        if(!details.hasAttribute('open')){ stack = ['root']; render(); }
      });
    }
    /* ----------------------------------------------------------------
       Niets mag over de open drawer heen (zie CLAUDE.md). In plaats van elke
       zwevende balk apart te patchen: bij het openen alle zichtbare
       position:fixed-elementen buiten de drawer en de header verbergen, en bij
       het sluiten in hun oude staat terugzetten. Dekt ook secties en widgets
       die later worden toegevoegd (sticky prijsbalk, mobiele branchebalk,
       WhatsApp-knop, vergelijkbalk, cookiebar, reviewbadge).
       Uitzondering: geef een element data-dga-keep als het mag blijven staan.
       ---------------------------------------------------------------- */
    var floaters = [];
    function hideFloaters(){
      if(floaters.length) return;
      var header = document.querySelector('.section-header');
      var all = document.body.querySelectorAll('*');
      for(var i = 0; i < all.length; i++){
        var el = all[i];
        if(el.hasAttribute('data-dga-keep')) continue;
        if(details && (details.contains(el) || el.contains(details))) continue;
        if(header && (header.contains(el) || el.contains(header))) continue;
        var cs = window.getComputedStyle(el);
        if(cs.position !== 'fixed') continue;
        if(cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
        floaters.push([el, el.style.visibility]);
        el.style.visibility = 'hidden';
      }
    }
    function showFloaters(){
      floaters.forEach(function(pair){ pair[0].style.visibility = pair[1] || ''; });
      floaters = [];
    }
    if(details){
      details.addEventListener('toggle', function(){
        if(details.hasAttribute('open')){
          /* na de openingsanimatie meten, anders kost de scan zichtbare tijd */
          window.requestAnimationFrame(hideFloaters);
        } else {
          showFloaters();
        }
      });
      if(details.hasAttribute('open')) window.requestAnimationFrame(hideFloaters);
    }

    /* Belknop: stipje groen/rood op basis van het zichtbare bericht van open-time.js */
    var call = mob.querySelector('[data-dga-mob-call]');
    if(call){
      var syncCall = function(){
        var shown = [].slice.call(document.querySelectorAll('.open-time .js-msg')).filter(function(m){ return m.style.visibility === 'visible'; })[0];
        call.classList.toggle('is-open', !!shown && shown.classList.contains('open'));
        call.classList.toggle('is-closed', !!shown && shown.classList.contains('close'));
        if(shown) call.setAttribute('title', shown.textContent.trim());
      };
      syncCall(); setTimeout(syncCall, 800);
      if(details) details.addEventListener('toggle', syncCall);
    }
    render();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initMobile);
  } else {
    initMobile();
  }
})();
